/**
 * Largeur de fenêtre à partir de laquelle une page de l'app tient en rangée (panneau à plusieurs
 * colonnes, quatre cartes côte à côte). En dessous, la barre latérale de 252 px et les marges ne
 * laissent que ~700 px au contenu : on garde la composition en colonne (blocs sous le panneau,
 * cartes deux par deux), même en gabarit étendu.
 */
export const LARGEUR_EN_RANGEE = 1360;
